export default {
  async showUnathorizedModal({ commit, dispatch }, status = true) {
    commit("showUnathorizedModal", status);

    dispatch("user/logout", "", { root: true });
  },
};
